import React from 'react'
import "./footer.css"
// import { Link, NavLink } from "react-router-dom";


const Footer = () => {
    return (
        <div className='footer'>
            <div className='sec1'>


                <div className='fieldbox'>

                    <p>Digital Craftsman from</p>
                    <div className='india'>

                    <h1> I</h1>
                    <h1> N </h1>
                    <h1> D </h1>
                    <h1> I </h1>
                    <h1> A</h1>

                    </div>



                    {/* <h5>Designed by Rahul Bishnoi</h5> */}
                </div>



            </div>

            {/* <div className='sec2'>
                <div className='section2_item'>
                    <div className='inner'>
                        <span> © designed by rahul </span>
                    </div>
                    <div className='inner'>
                        <span> © designed by rahul </span>
                    </div>


                </div>
            </div> */}
        </div>
    )
}

export default Footer